module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "container",
    staticClass: "resumeEditor",
    class: {
      htmlMode: _vm.enableHtml
    }
  }, [(_vm.enableHtml) ? _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.resume)
    }
  }) : _c('pre', [_vm._v(_vm._s(_vm.resume))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/._vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-7e72c7aa","hasScoped":true}!./~/._vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/ResumeEditor.vue
// module id = 96
// module chunks = 1